/**
 * 画面表示用の軍用・システムUI風コピー（単一ソース）
 */

export const uiLexicon = {
  metaDescription:
    "PROTO RECON — カメラ・ナビ・センサ情報を端末内で統合表示する実験モジュール。",

  documentTitle: "PROTO RECON — CAMERA",

  splash: {
    brand: "PROTO RECON",
    lead:
      "カメラ・ナビゲーション・機動センサを統合。端末内クローズド処理でリアルタイム表示します。",
    manifest:
      "動画ストリーム上の物体を検出し、照準ロックのみを目的とした軽量モジュールです。運用要件の規定は保持しません。",
    checks: [
      "映像処理・物体検出・顔領域マスキングはすべて端末内で実行されます。",
      "位置情報は地図オーバレイおよび対地速度表示に使用されます。",
      "地図タイル: OpenStreetMap / CARTO（外部取得）。",
    ],
    arTitle: "カメラ透過運用時の注意事項",
    arBullets: [
      "起動前に周囲の安全を確認してください（歩行者・障害物・通路占有）。",
      "移動中は画面に固定せず、操作時は立ち止まってください。",
      "車両往来・段差・障害物に留意し、公共空間ではプライバシーに配慮してください。",
      "長時間連続使用は避け、眼部・身体負荷を抑えるため適宜休憩してください。",
    ],
    startBtn: "カメラを起動",
    policySummary: "コンプライアンス・ライセンス情報",
    policyNote:
      "公開運用時は、利用目的・保存期間・問い合わせ先を含む正式なプライバシーポリシーを用意してください。",
    policyPrivacyLink: "プライバシーポリシー",
    policyOssLink: "OSS / サードパーティ表記",
  },

  seqBanner: {
    label: "INIT SEQUENCE",
    sub: "UI LINK / LOCAL SESSION",
  },

  aria: {
    bootSteps: "ブートシーケンス",
    checks: "運用上の要点",
    arCaution: "安全上の注意",
    video: "カメラ映像",
    stopCamera: "カメラを停止",
    compass: "方位インジケータ",
    miniMap: "戦術地図オーバレイ（現在地）",
  },

  stopFab: "切断",

  liveHud: {
    title: "PROTO RECON",
    mapTitle: "OVL MAP",
  },

  /** 右下・GPS 換算の対地速度表示 */
  speedHud: {
    label: "SPD",
    unit: "km/h",
  },

  errors: {
    browserCamera:
      "カメラ: ブラウザ非対応、または HTTPS / localhost 以外で開いています。",
    browserOrientation: "方位API: このブラウザでは利用できません。",
    orientationPermission:
      "方位センサ: アクセスが拒否されています（OS設定から許可してください）。",
    cameraGeneric: "カメラを取得できませんでした。",
    cameraTimeout:
      "カメラ接続がタイムアウトしました。許可ダイアログを確認するか、再試行してください。",
    modelTimeout:
      "検知モデルの読込がタイムアウトしました。回線を確認して再試行してください。",
  },

  /** ライブ中の負荷・異常（`liveHealth.js`） */
  health: {
    inferSlow:
      "処理遅延: 端末負荷が高い可能性があります。冷却後に再試行してください。",
    inferFail: "検知エラー: 一度停止してから再起動してください。",
    videoStall:
      "映像停止: カメラが進んでいません。停止後に再起動してください。",
    generic: "システム負荷: 動作が不安定です。",
  },

  boot: {
    preparing: "プリフライト実行中…",
    loadingDual: "検知モデル・顔検知サブシステム読込中…",
    loadingSsd: "物体検知モデル読込中…",
    connecting: "カメラに接続しています…",
    startAgain: "カメラを起動",
  },

  miniMap: {
    acquiring: "GNSSフィックス取得中…",
    tileSource: "SRC: OSM / CARTO · ラベル無し",
    initFail: "地図サブシステム初期化失敗",
    geoDenied: "位置情報: アクセス拒否",
    geoUnavailable: "位置: 測位不可",
    geoTimeout: "位置: 取得タイムアウト",
  },

  motion: {
    shakeDetect: "機動検知",
  },
};

/**
 * スプラッシュのチェックリスト `<ul class="splash__checks">` を同期する
 * @param {ParentNode} [root]
 */
export function applySplashChecklist(root = document) {
  const ul = root.querySelector(".splash__checks");
  if (!ul) return;
  const items = ul.querySelectorAll("li");
  uiLexicon.splash.checks.forEach((text, i) => {
    if (items[i]) items[i].textContent = text;
  });
}

/**
 * AR注意リストを同期する
 * @param {ParentNode} [root]
 */
export function applyArCautionList(root = document) {
  const ul = root.querySelector(".splash__ar-caution-list");
  if (!ul) return;
  const items = ul.querySelectorAll("li");
  uiLexicon.splash.arBullets.forEach((text, i) => {
    if (items[i]) items[i].textContent = text;
  });
}
